import { Title } from "../../components/AboutUsPageComponents/Title/Title";
import { WhoWeAre } from "../../components/AboutUsPageComponents/WhoWeAre/WhoWeAre";
import { Loading } from "../../components/CommonComponents/Loading/Loading";
import { Basement } from "../../components/CummonComponents/Basement/Basement";
import { Map } from "../../components/CummonComponents/Map/Map";
import { ParallaxBackground } from "../../components/CummonComponents/ParallaxBackground/ParallaxBackground";
import { useAbout, useImageUrl } from "../../queries";
import { Container } from "./styled";
import {Helmet} from "react-helmet-async";
import {APP_NAME} from "../../utils/constants";


export const AboutUs = ()=>{
    const {data: aboutData, isLoading} = useAbout()
    const headerImageUrl = useImageUrl(aboutData?.header_background);

    return (
        <>
            <Helmet>
                <title>About Us | {APP_NAME}</title>
            </Helmet>
            {isLoading ? (
                <Loading />
            ) : !aboutData ? (
                null
            ) : (
                <Container>
                    <ParallaxBackground
                        imageUrl={headerImageUrl}
                        speedFactor={-0.5}
                    />
                    <Title title={aboutData.header_title}/>
                    <WhoWeAre
                        title={aboutData.who_are_title}
                        description={aboutData.who_are_description}
                    />
                    <Basement back={false} data={aboutData}/>
                    <Map data={aboutData?.about_us}/>
                </Container>
            )}
        </>
    )
}
